import { FC, Fragment } from 'react';
// Hooks
import useToggle from 'app/hooks/useToggle';
// Components
import { Fab } from 'app/components/Mui';
// 
import ServiceFormDialog from './ServiceForm.dialog';
// i18next
import { useTranslation } from 'react-i18next';

const ServicesFab:FC = () => {
  const { t } = useTranslation();

  const { open, toggle } = useToggle();

  return (
    <Fragment>
      <Fab
        name="Create billing service"
        sx={{
          position: 'fixed',
          right: 16,
          bottom: 16
        }}
        variant="extended"
        color="primary"
        onClick={toggle}
      >{t('pages.billingServices.createButton')}</Fab>
      {/* Service create form dialog */}
      {open ? (
        <ServiceFormDialog
          open={open}
          onClose={toggle}
        />
      ) : null}
    </Fragment>
  )
}

export default ServicesFab;
